import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { FocusVisibleManager } from "use-focus-visible";
import { Icon } from "../../../icon";
import { KeyBoardKeys } from "../../../types";
import { Toggle } from "../../../toggle";
import { OptionsContainer } from "./options-container.styles";
import { Label } from "../label/Label.styles";
import { DropdownContainer, SelectExtended } from "./extended-dropdown.styles";
import { Trigger } from "./trigger";
export const ExtendedDropdown = ({ onChange, label, placeholder, required, items = [], flyoutMaxItemsCount = 5, previewId, isOpen, allSelectionLabel, outlined, renderFooter, values: initialValues = [], }) => {
    const customSelectRef = React.useRef(null);
    const [values, setValues] = React.useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [isOpened, setIsOpened] = useState(false);
    useEffect(() => {
        if (isOpen !== isOpened) {
            setIsOpened(isOpen);
        }
    }, [isOpen]);
    useEffect(() => {
        if (initialValues) {
            setValues(initialValues);
        }
    }, [initialValues.length]);
    useEffect(() => {
        function watchClickOutside(e) {
            const didClickedOutside = !customSelectRef.current.contains(e.target);
            if (didClickedOutside) {
                setIsOpened(false);
            }
        }
        document.addEventListener("click", watchClickOutside);
        return () => {
            document.removeEventListener("click", watchClickOutside);
        };
    }, [isOpened, isFocused]);
    useEffect(() => {
        const getHandler = (optionContainer, option, labelElement) => (e) => {
            if (e.key === KeyBoardKeys.Enter ||
                e.key === KeyBoardKeys.Space ||
                e.key === " ") {
                optionContainer.forEach((o) => {
                    o.classList.remove("focused");
                });
                labelElement.click();
                option.classList.add("focused");
                option.focus();
            }
        };
        const handleFocus = () => {
            const optionContainer = customSelectRef.current.querySelectorAll('div[type="checkboxGroup"]');
            optionContainer.forEach((option) => {
                option.setAttribute("tabindex", "0");
                const inputElement = option.querySelector("input");
                if (!inputElement)
                    return;
                inputElement.setAttribute("tabindex", "-1");
                const labelElement = option.querySelector("label");
                if (!labelElement)
                    return;
                const KeyUpHandler = getHandler(optionContainer, option, labelElement);
                option.removeEventListener("keyup", KeyUpHandler);
                option.addEventListener("keyup", KeyUpHandler);
            });
        };
        const observer = new MutationObserver(handleFocus);
        if (customSelectRef.current) {
            try {
                observer.observe(customSelectRef.current, {
                    childList: true,
                    attributes: true,
                });
            }
            catch (e) {
                /** silent error */
            }
        }
        return () => {
            try {
                observer.disconnect();
            }
            catch (e) {
                /** silent error */
            }
        };
    }, []);
    useEffect(() => {
        if (isOpen) {
            const optionContainer = customSelectRef.current.querySelectorAll('div[type="checkboxGroup"]');
            optionContainer.forEach((option) => {
                option.classList.remove("focused");
            });
        }
    }, [isOpen]);
    useEffect(() => {
        if (typeof onChange === "function") {
            onChange(values);
        }
    }, [values]);
    const onAllChange = (status) => {
        if (!status || status === "Minus") {
            setValues([...items.map((obj) => obj.value)]);
        }
        else {
            setValues([]);
        }
    };
    const onValueChange = (value) => {
        if (values.includes(value)) {
            setValues(values.filter((obj) => obj !== value));
        }
        else {
            setValues(Array.from(new Set([...values, value])));
        }
    };
    return (_jsx(FocusVisibleManager, { children: _jsxs(DropdownContainer, Object.assign({ className: "gdds-multi-select" }, { children: [label && (_jsxs(Label, Object.assign({ id: "label" }, { children: [label, label && required && "*"] }))), _jsxs(SelectExtended, Object.assign({ opened: isOpened, "data-preview-id": previewId, ref: customSelectRef, "aria-hidden": !isOpened }, { children: [_jsx(Icon, { withHitSpace: true, symbol: "ChevronDown" }), _jsx(Trigger, { outlined: outlined, isOpened: isOpened, onClick: () => {
                                setIsOpened((o) => {
                                    return !o;
                                });
                            }, value: values.length === items.length
                                ? allSelectionLabel
                                : values.length > 0
                                    ? values
                                        .map((e) => { var _a; return (_a = items.find((ee) => ee.value === e)) === null || _a === void 0 ? void 0 : _a.text; })
                                        .join(", ")
                                    : placeholder, hasInitialSelectionChanged: values.length > 0 }), _jsx(OptionsContainer, Object.assign({ tabIndex: -1, flyoutMaxItemsCount: flyoutMaxItemsCount, opened: isOpened, focused: isFocused, withFooter: !!renderFooter, onKeyUp: (e) => {
                                if (e.key === KeyBoardKeys.Tab) {
                                    setIsFocused(true);
                                }
                            }, onBlur: () => {
                                setIsFocused(false);
                            } }, { children: _jsx(Toggle, { onChange: onValueChange, onAllChange: onAllChange, values: { "gdds-group-select": values }, items: items, label: allSelectionLabel, type: "checkboxGroup", name: "gdds-group-select" }) }))] }))] })) }));
};
